module.exports = __webpack_public_path__ + "static/media/point-blank.4067a61c.mp3";